import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { Stack } from "@mui/material";
import { useColorPicker } from "../../hooks/useColorPicker.js";
import { Swatch } from "../Swatch/Swatch.js";
import { Grid } from "./components/Grid/Grid.js";
import { NO_COLOR } from "../../constants.js";
import { Footer } from "../Footer.js";
import { Placeholder } from "../Placeholder/Placeholder.js";
import { CustomColorGroups } from "./components/CustomColorGroups/CustomColorGroups.js";
import { usePaletteMaxHeight } from "./hooks/usePaletteMaxHeight.js";
function Palette(props) {
  const { palette: rawPalette, testId = "ColorPicker--Palette" } = props;
  const {
    selection,
    onChange,
    customColors,
    onAddColor,
    placeholderMode,
    swatchesPerRow,
    goToAddColorToPalette,
    localeText,
    autoCommit,
    onCommit,
    onCancel,
    allowNoColor,
    maxRowsBeforeScrolling,
    swatchSize,
    swatchesGap
  } = useColorPicker();
  const noColorPaletteItem = {
    color: NO_COLOR,
    label: localeText.noColorLabel
  };
  const palette = allowNoColor ? [noColorPaletteItem, ...rawPalette] : rawPalette;
  const canAddColor = !!onAddColor && customColors === "add-inline";
  const lastRowChipsCount = palette.length % swatchesPerRow;
  const placeholdersCount = canAddColor ? placeholderMode === "fill-row" ? swatchesPerRow - lastRowChipsCount : 1 : 0;
  const placeholderDisabled = false;
  const maxHeight = usePaletteMaxHeight({ palette, maxRowsBeforeScrolling, swatchesGap, swatchesPerRow, swatchSize });
  const renderCustomColorGroups = customColors !== "none" && customColors !== "add-inline";
  return /* @__PURE__ */ jsxs(Stack, { gap: 2, "data-testid": testId, children: [
    /* @__PURE__ */ jsxs(Stack, { gap: 1, children: [
      /* @__PURE__ */ jsxs(Grid, { maxHeight, testId: "Palette--Grid", children: [
        palette.map((color) => /* @__PURE__ */ createElement(
          Swatch,
          {
            ...color,
            localeText,
            key: color.color,
            selected: selection.has(color.color),
            onSelect: onChange,
            swatchSize
          }
        )),
        Array.from({ length: placeholdersCount }).map((_, idx) => /* @__PURE__ */ jsx(
          Placeholder,
          {
            swatchSize,
            onClick: goToAddColorToPalette,
            disabled: placeholderDisabled,
            tooltip: placeholderDisabled ? localeText.addColorDisabledTooltip : localeText.addColorTooltip
          },
          idx
        ))
      ] }),
      renderCustomColorGroups && /* @__PURE__ */ jsx(CustomColorGroups, { customColors })
    ] }),
    !autoCommit && /* @__PURE__ */ jsx(Footer, { onCommit, onCancel })
  ] });
}
export {
  Palette
};
//# sourceMappingURL=Palette.js.map
